export { App as default } from '@guiker/booking-main-mfe'
